import React from "react";
import { Link } from "react-router-dom";
import { CELL_STYLE } from "./PaymentReportRow";

/** Renders the current page of a PATIENT_DEBIT_REPORT result. */
export default function PatientDebitList({ data, offset, limit }) {
    return (
        <tbody>
            {data &&
                data.providerpatientdebitreport &&
                data.providerpatientdebitreport.slice(offset, limit).map((patient) => <TableRow key={patient.patient_id} {...patient} />)}
        </tbody>
    );
}

function TableRow({ patient_id, member_id, first_name, last_name, date_of_birth }) {
    function viewPatient() {
        window.localStorage.setItem("xrefID", parseInt(patient_id));
    }

    return (
        <tr>
            <td style={CELL_STYLE}>{member_id}</td>
            <td style={CELL_STYLE}>
                <Link onClick={viewPatient} to="../patient-informations">
                    {first_name} {last_name}
                </Link>
            </td>
            <td style={CELL_STYLE}>{date_of_birth}</td>
        </tr>
    );
}


